// extracted by mini-css-extract-plugin
export var dropdownIcon = "_op-6";
export var imgContainer = "_op-3";
export var menuIcon = "_op-5";
export var pillWrapper = "_op-2";
export var pillsContainer = "_op-1";
export var subscriptionCard = "_op-0";
export var subscriptionLogo = "_op-4";